import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-saved-searches',
  templateUrl: './saved-searches.component.html',
  styleUrls: ['./saved-searches.component.scss'],
})
export class SavedSearchesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
